'use client';

import { Suspense } from 'react';
import { useSearchParams } from 'next/navigation';
import { SignUp } from '@clerk/nextjs';
import { isLocalAuth } from '@/lib/authMode';
import { LocalSignUp } from '@/components/auth/LocalSignUp';
import { useLocale, useTranslations } from 'next-intl';

// Registrazione via Clerk: account + verifica email gestiti da Clerk.
// La creazione del workspace avviene DOPO il login (onboarding via Convex,
// gestito in WorkspaceContext: utente senza workspace -> schermata "crea workspace").
// signInUrl mantiene il prefisso locale corrente (la lingua scelta non si perde
// passando a "Accedi"); il param ?redirect= (es. flusso invito) viene rispettato.
function ClerkSignUp() {
  const locale = useLocale();
  const searchParams = useSearchParams();
  const raw = searchParams.get('redirect') || '/app/dashboard';
  const redirectTo = raw.startsWith('/') ? raw : '/app/dashboard';
  const prefix = locale === 'en' ? '' : `/${locale}`;
  return (
    <SignUp
      routing="hash"
      signInUrl={`${prefix}/login?redirect=${encodeURIComponent(redirectTo)}`}
      fallbackRedirectUrl={redirectTo}
      forceRedirectUrl={redirectTo}
    />
  );
}

export default function SignupPage() {
  const t = useTranslations('Auth.login');
  return (
    <div className="min-h-screen flex">
      <div className="hidden md:flex md:w-[480px] lg:w-[520px] shrink-0 bg-stone-950 dark:bg-zinc-800 relative overflow-hidden flex-col items-center justify-center p-12">
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'url(/marble-dark.svg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            opacity: 0.5,
            maskImage: 'radial-gradient(ellipse at 30% 50%, black 0%, transparent 70%)',
            WebkitMaskImage: 'radial-gradient(ellipse at 30% 50%, black 0%, transparent 70%)',
          }}
        />
        <div className="relative flex flex-col items-center text-center gap-8">
          <div className="flex items-center gap-3">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/logo-white.webp" alt="" width={26} height={26} style={{ width: 26, height: 26, objectFit: 'contain' }} />
            <span className="font-semibold text-lg tracking-tight text-stone-50">Lithosbase</span>
          </div>
          <div>
            <p className="text-[11px] font-mono tracking-[0.14em] uppercase mb-4" style={{ color: '#C9B585' }}>
              Stone warehouse management
            </p>
            <h2 className="text-2xl font-bold tracking-tight text-stone-50 max-w-[240px] leading-snug">
              {t('title')}
            </h2>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center bg-stone-50 dark:bg-zinc-950 p-6 md:p-12">
        <Suspense>
          {/* Sull'installazione del cliente questa schermata serve una volta
              sola: crea l'amministratore alla prima accensione. */}
          {isLocalAuth() ? <LocalSignUp /> : <ClerkSignUp />}
        </Suspense>
      </div>
    </div>
  );
}
